import { createCRUDHook } from './createCRUDHook';
import { checkListTemplatePartDto } from 'utils/models';
import { TBL_CHECKLIST_TEMPLATE_PART } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<checkListTemplatePartDto>({
    entityName: 'CheckListTemplatePart',
    endpoint: TBL_CHECKLIST_TEMPLATE_PART,
  });

export const CheckListTemplatePartContext = Context;
export const useCheckListTemplatePartManager = useManager;
export const useCheckListTemplatePart = useConsumer;
